module.exports = __webpack_public_path__ + "static/img/78091J_1_R_20201130_LC.e4ec6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78091J_1_R_20201130_LC.png
// module id = OFnf
// module chunks = 0